import Seo from "@/components/Seo"
import React from "react"
import PhilosophySection from "./PhilosophySection"
import TransactionSection from "./TransactionSection"
import FeaturesSection from "./FeaturesSection"
import CommunitySection from "./CommunitySection"
import { LearnMoreSection } from "./LearnMoreSection"
import { LowerRegions } from "@/configs/region"
import { getRegionConfig } from "./getRegionConfig"
import { usePageRegion } from "../NavBar/usePageRegion"

const SecurityPage = () => {
  const { pageRegion } = usePageRegion()
  const region = pageRegion ? pageRegion.toLowerCase() : "global"
  const config = getRegionConfig(region as LowerRegions)
  const { isShowLearnSection, transactionContent } = config

  return (
    <>
      <Seo page="security" />
      <PhilosophySection />
      <TransactionSection transactionContent={transactionContent} />
      <FeaturesSection />
      <CommunitySection />
      {isShowLearnSection && <LearnMoreSection />}
    </>
  )
}

export default SecurityPage
